import styled from 'styled-components';
import devices from '../../styles/devices.js';
import { theme } from '../../styles/theme.js';
import viewport from '../../utils/viewport.js';
const ModalContainer = styled.div`
  height: auto;
  min-width: 480px;
  border: none;
  border-radius: ${theme.border.borderRadius};
  background-color: ${theme.color.white};
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  overflow: visible;

  @media (${devices.phone_small}) {
    ${viewport.height};
    width: 100vw;
    min-width: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto 0;
    border-radius: 0;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }
`;
export { ModalContainer };
//# sourceMappingURL=ModalContainer.js.map
